

export const loadChildrenMixin = {
  props: {
    node: {
      type: Object,
      required: true,
    },
    loadChildren: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async onLoadChildren() {
      const { node } = this

      if (node.isLast || node.isActive) {
        this.toggle()
        return
      }

      await this.loadChildren(node)
      this.$nextTick(this.toggle)
    },
    toggle() {
      this.node.isActive = !this.node.isActive
    },
  },
}
